import { Link } from "react-router-dom";
import moment from "moment";
import { MagnifyingGlass } from "react-loader-spinner";
import { capitalize } from "@mui/material";

const CustomExam = ({ dynamicExams, dynamicLoading, userData, pagination, onPageChange, currentType }) => {
    return (
        <div className="mt-3">

            {/* HEADER */}
            {userData?.enrolledCourses?.some(c => c.type === "Dynamic") ? (
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Practice Exams</h5>

                    <Link to="/generate-exam">
                        <button className="btn btn-primary btn-sm rounded-pill px-3">
                            + Generate Exam
                        </button>
                    </Link>
                </div>
            ) : (
                <div className="alert alert-warning">
                    Subscribe Topic Wise Course to Generate Custom Exams
                </div>
            )}

            {/* LOADING */}
            {dynamicLoading && (
                <div className="text-center">
                    <MagnifyingGlass height="60" width="60" color="#8000df" />
                </div>
            )}

<div className="mt-3" style={{ overflowX: "auto" }}>
  <table className="table table-bordered align-middle">
    <thead className="table-light">
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Date</th>
        <th>Status</th>
        <th>Difficulty</th>
        <th>Result</th>
        <th>Review</th>
        <th>Question Paper</th>
        <th>Solution</th>
      </tr>
    </thead>

    <tbody>
      {/* LOADING */}
      {dynamicLoading && (
        <tr>
          <td colSpan={5} className="text-center">
            <MagnifyingGlass height="60" width="60" color="#8000df" />
          </td>
        </tr>
      )}

      {/* EMPTY */}
      {!dynamicLoading && dynamicExams.length === 0 && (
        <tr>
          <td colSpan={5} className="text-center text-muted">
            No practice exams generated yet.
          </td>
        </tr>
      )}

      {/* DATA */}
      {!dynamicLoading &&
        dynamicExams.map((item, i) => {
          const srNo =
            ((pagination?.currentPage || 1) - 1) *
            (pagination?.limit || 10) +
            i +
            1;
          return(
          <tr key={i}>
             <td>{srNo}</td>
            {/* NAME */}
            <td>{item.exam.examName}</td>

            {/* DATE */}
            <td>
              {moment(item.exam.createdAt).format("Do MMM YYYY")}
            </td>

            {/* STATUS */}
            <td>
              {item.attempt ? (
                <button className="btn btn-sm btn-info">Attempted</button>
              ) : (
                <Link to={`/dynamic-exam/${item.exam._id}`}>
                  <button className="btn btn-sm btn-success">
                    Start
                  </button>
                </Link>
              )}
            </td>
            <td>
              <span
                className={`badge p-1 ${item.exam.difficulty === 'easy'
                    ? 'bg-success'
                    : item.exam.difficulty === 'medium'
                      ? 'bg-warning text-dark'
                      : item.exam.difficulty === 'hard'
                        ? 'bg-danger'
                        : 'bg-secondary'
                  }`}
              >
                {capitalize(item.exam.difficulty)}
              </span>
            </td>


            {/* RESULT */}
            <td>
              {item.attempt ? (
                <Link to={`/dynamic-exam/result/${item.attempt.examId}`}>
                  View
                </Link>
              ) : (
                "NA"
              )}
            </td>

            {/* REVIEW */}
            <td>
              {item.attempt ? (
                <Link to={`/dynamic-exam/twp/review/${item.exam._id}`}>
                  Review
                </Link>
              ) : (
                "NA"
              )}
            </td>
            <td>
              {item.attempt ? (
                <Link to={`/dynamic-exam/twp/question-paper/${item.exam._id}`}>
                  Review
                </Link>
              ) : (
                "NA"
              )}
            </td>
            <td>
              {item.attempt ? (
                <Link to={`/dynamic-exam/twp/solution/${item.exam._id}`}>
                  Review
                </Link>
              ) : (
                "NA"
              )}
            </td>
          </tr>
        )})}
    </tbody>
  </table>

  {/* Pagination */}
  {pagination && pagination.totalPages > 1 && (
    <div className="d-flex justify-content-center mt-3">
      <nav>
        <ul className="pagination">
          <li className={`page-item ${!pagination.hasPrevPage ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentType, pagination.currentPage - 1)}
              disabled={!pagination.hasPrevPage}
            >
              Previous
            </button>
          </li>

          {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map(pageNum => (
            <li key={pageNum} className={`page-item ${pageNum === pagination.currentPage ? 'active' : ''}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(currentType, pageNum)}
              >
                {pageNum}
              </button>
            </li>
          ))}

          <li className={`page-item ${!pagination.hasNextPage ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentType, pagination.currentPage + 1)}
              disabled={!pagination.hasNextPage}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  )}

  {pagination && (
    <div className="text-center mt-2 text-muted">
      Showing {dynamicExams.length} of {pagination.totalExams} exams
    </div>
  )}
</div>


        </div>
    );
};

export default CustomExam;